import * as _ from 'lodash';
import { loadTranslations } from 'react-redux-i18n-lite';
/* eslint-disable camelcase */
import genericTranslationsES from '../../translations/es/generic.json';
import genericTranslationsES_AR from '../../translations/es-ar/generic.json';
import genericTranslationsES_MX from '../../translations/es-mx/generic.json';
import genericTranslationsES_CO from '../../translations/es-co/generic.json';
import genericTranslationsES_EC from '../../translations/es-ec/generic.json';
import genericTranslationsES_PR from '../../translations/es-pr/generic.json';
import genericTranslationsES_PE from '../../translations/es-pe/generic.json';
import genericTranslationsEN from '../../translations/en/generic.json';
import genericTranslationsDE from '../../translations/de/generic.json';
import genericTranslationsGL from '../../translations/gl/generic.json';
import genericTranslationsBO from '../../translations/es-bo/generic.json';
import genericTranslationsPT_BR from '../../translations/pt-br/generic.json';

import apiTranslationsES from '../../translations/es/api.json';
import apiTranslationsES_AR from '../../translations/es-ar/api.json';
import apiTranslationsES_MX from '../../translations/es-mx/api.json';
import apiTranslationsES_CO from '../../translations/es-co/api.json';
import apiTranslationsES_EC from '../../translations/es-ec/api.json';
import apiTranslationsES_PE from '../../translations/es-pe/api.json';
import apiTranslationsES_PR from '../../translations/es-pr/api.json';
import apiTranslationsEN from '../../translations/en/api.json';
import apiTranslationsDE from '../../translations/de/api.json';
import apiTranslationsGL from '../../translations/gl/api.json';
import apiTranslationsBO from '../../translations/es-bo/api.json';
import apiTranslationsPT_BR from '../../translations/pt-br/api.json';

import panelsTranslationsES from '../../translations/es/panels.json';
import panelsTranslationsES_AR from '../../translations/es-ar/panels.json';
import panelsTranslationsES_MX from '../../translations/es-mx/panels.json';
import panelsTranslationsES_CO from '../../translations/es-co/panels.json';
import panelsTranslationsES_EC from '../../translations/es-ec/panels.json';
import panelsTranslationsES_PE from '../../translations/es-pe/panels.json';
import panelsTranslationsES_PR from '../../translations/es-pr/panels.json';
import panelsTranslationsEN from '../../translations/en/panels.json';
import panelsTranslationsDE from '../../translations/de/panels.json';
import panelsTranslationsGL from '../../translations/gl/panels.json';
import panelsTranslationsBO from '../../translations/es-bo/panels.json';
import panelsTranslationsPT_BR from '../../translations/pt-br/panels.json';

import discussionsTranslationsES from '../../translations/es/discussions.json';
import discussionsTranslationsES_AR from '../../translations/es-ar/discussions.json';
import discussionsTranslationsES_MX from '../../translations/es-mx/discussions.json';
import discussionsTranslationsES_CO from '../../translations/es-co/discussions.json';
import discussionsTranslationsES_EC from '../../translations/es-ec/discussions.json';
import discussionsTranslationsES_PE from '../../translations/es-pe/discussions.json';
import discussionsTranslationsES_PR from '../../translations/es-pr/discussions.json';
import discussionsTranslationsEN from '../../translations/en/discussions.json';
import discussionsTranslationsDE from '../../translations/de/discussions.json';
import discussionsTranslationsGL from '../../translations/gl/discussions.json';
import discussionsTranslationsBO from '../../translations/es-bo/discussions.json';
import discussionsTranslationsPT_BR from '../../translations/pt-br/discussions.json';

import participantsTranslationsES from '../../translations/es/participants.json';
import participantsTranslationsES_AR from '../../translations/es-ar/participants.json';
import participantsTranslationsES_MX from '../../translations/es-mx/participants.json';
import participantsTranslationsES_CO from '../../translations/es-co/participants.json';
import participantsTranslationsES_EC from '../../translations/es-ec/participants.json';
import participantsTranslationsES_PE from '../../translations/es-pe/participants.json';
import participantsTranslationsES_PR from '../../translations/es-pr/participants.json';
import participantsTranslationsEN from '../../translations/en/participants.json';
import participantsTranslationsDE from '../../translations/de/participants.json';
import participantsTranslationsGL from '../../translations/gl/participants.json';
import participantsTranslationsBO from '../../translations/es-bo/participants.json';
import participantsTranslationsPT_BR from '../../translations/pt-br/participants.json';
import corporateOverrideES from '../../translations/es/corporate-override.json';
import corporateOverrideEN from '../../translations/en/corporate-override.json';
import corporateOverrideDE from '../../translations/de/corporate-override.json';
import corporateOverrideES_AR from '../../translations/es-ar/corporate-override.json';
import corporateOverrideES_BO from '../../translations/es-bo/corporate-override.json';
import corporateOverrideES_CO from '../../translations/es-co/corporate-override.json';
import corporateOverrideES_EC from '../../translations/es-ec/corporate-override.json';
import corporateOverrideES_MX from '../../translations/es-mx/corporate-override.json';
import corporateOverrideES_PE from '../../translations/es-pe/corporate-override.json';
import corporateOverrideES_PR from '../../translations/es-pr/corporate-override.json';
import corporateOverrideGL from '../../translations/gl/corporate-override.json';
import corporateOverridePT_BR from '../../translations/pt-br/corporate-override.json';

import { CLASSROOM_MODES, USER } from '../../const';

export const translationsObject = (classroomMode = CLASSROOM_MODES.EDUCATIONAL) => {
  // Generic translations
  const en = genericTranslationsEN;
  const es = genericTranslationsES;
  const esAr = genericTranslationsES_AR;
  const esMx = genericTranslationsES_MX;
  const esCo = genericTranslationsES_CO;
  const esEc = genericTranslationsES_EC;
  const esPe = genericTranslationsES_PE;
  const esPr = genericTranslationsES_PR;
  const de = genericTranslationsDE;
  const gl = genericTranslationsGL;
  const esBo = genericTranslationsBO;
  const ptBr = genericTranslationsPT_BR;

  // Add API translations
  en.api = apiTranslationsEN;
  es.api = apiTranslationsES;
  esAr.api = apiTranslationsES_AR;
  esMx.api = apiTranslationsES_MX;
  esCo.api = apiTranslationsES_CO;
  esEc.api = apiTranslationsES_EC;
  esPe.api = apiTranslationsES_PE;
  esPr.api = apiTranslationsES_PR;
  de.api = apiTranslationsDE;
  gl.api = apiTranslationsGL;
  esBo.api = apiTranslationsBO;
  ptBr.api = apiTranslationsPT_BR;

  // Add panels translations
  en.panels = panelsTranslationsEN;
  es.panels = panelsTranslationsES;
  esAr.panels = panelsTranslationsES_AR;
  esMx.panels = panelsTranslationsES_MX;
  esCo.panels = panelsTranslationsES_CO;
  esEc.panels = panelsTranslationsES_EC;
  esPe.panels = panelsTranslationsES_PE;
  esPr.panels = panelsTranslationsES_PR;
  de.panels = panelsTranslationsDE;
  gl.panels = panelsTranslationsGL;
  esBo.panels = panelsTranslationsBO;
  ptBr.panels = panelsTranslationsPT_BR;

  // Add discussions translations
  es.discussions = discussionsTranslationsES;
  en.discussions = discussionsTranslationsEN;
  esAr.discussions = discussionsTranslationsES_AR;
  esMx.discussions = discussionsTranslationsES_MX;
  esCo.discussions = discussionsTranslationsES_CO;
  esEc.discussions = discussionsTranslationsES_EC;
  esPe.discussions = discussionsTranslationsES_PE;
  esPr.discussions = discussionsTranslationsES_PR;
  de.discussions = discussionsTranslationsDE;
  gl.discussions = discussionsTranslationsGL;
  esBo.discussions = discussionsTranslationsBO;
  ptBr.discussions = discussionsTranslationsPT_BR;

  // Add participants translations
  es.participants = participantsTranslationsES;
  en.participants = participantsTranslationsEN;
  esAr.participants = participantsTranslationsES_AR;
  esMx.participants = participantsTranslationsES_MX;
  esCo.participants = participantsTranslationsES_CO;
  esEc.participants = participantsTranslationsES_EC;
  esPe.participants = participantsTranslationsES_PE;
  esPr.participants = participantsTranslationsES_PR;
  de.participants = participantsTranslationsDE;
  gl.participants = participantsTranslationsGL;
  esBo.participants = participantsTranslationsBO;
  ptBr.participants = participantsTranslationsPT_BR;

  if (CLASSROOM_MODES.CORPORATE === classroomMode) {
    _.merge(es, corporateOverrideES);
    _.merge(en, corporateOverrideEN);
    _.merge(de, corporateOverrideDE);
    _.merge(esAr, corporateOverrideES_AR);
    _.merge(esBo, corporateOverrideES_BO);
    _.merge(esCo, corporateOverrideES_CO);
    _.merge(esEc, corporateOverrideES_EC);
    _.merge(esMx, corporateOverrideES_MX);
    _.merge(esPe, corporateOverrideES_PE);
    _.merge(esPr, corporateOverrideES_PR);
    _.merge(gl, corporateOverrideGL);
    _.merge(ptBr, corporateOverridePT_BR);
  }

  return {
    en,
    es,
    'es-ar': esAr,
    'es-mx': esMx,
    'es-co': esCo,
    'es-ec': esEc,
    'es-pe': esPe,
    'es-bo': esBo,
    'es-pr': esPr,
    de,
    gl,
    'pt-br': ptBr
  };
};
export const setTranslations = (store = {}) => {
  store.dispatch(loadTranslations(translationsObject()));
};

export let getDefaultLanguage = () => {
  let navigatorLanguage = (navigator.language || navigator.userLanguage).toLowerCase();
  let defaultLanguage = USER.LANGUAGES[0].value;

  navigatorLanguage = navigatorLanguage === 'es_es' ? navigatorLanguage : 'es';
  if (isValidLanguage(navigatorLanguage)) {
    defaultLanguage = navigatorLanguage;
  }

  return defaultLanguage;
};

function isValidLanguage(navigatorLanguage) {
  let index = _.findIndex(USER.LANGUAGES, lang => {
    return lang.value === navigatorLanguage;
  });
  return index >= 0;
}

/* eslint-enable camelcase */
